<template>
  <div v-if="info">
    <div :style="background ? `background: url('${background}');width: 100%; height: 100vh;background-size: cover;padding-top: 25vh;`: ''">
      <div v-if="winner" class="text-left winner" style="color: white;">
        <h1 style="font-size: 8.5vh;
    width: 100vw;
        padding-left: 20vw;
    margin-top: 11vh;">{{ winner.prize }}</h1>
        <h1 style="font-size: 7.5vh;margin-top: 2vh;    padding-left: 20vw;">{{ winner.surveyAnswer.result.lastName }} {{ winner.surveyAnswer.result.firstName }}</h1>
        <h2 style="    padding-left: 20vw;">Штрихкод: {{ winner.surveyAnswer.barcode }}</h2>
      </div>
    </div>
  </div>
<!--  <dashboard-layout>-->
<!--  </dashboard-layout>-->
</template>

<script>
  import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout.vue'
  import PButton from '../../UIComponents/Button'
  import swal from 'sweetalert2'


  export default {
    components: {
      PButton,
      DashboardLayout
    },
    name: 'lottery-admin',
    props: {
      lotteryId: {
        type: Number,
        default () {
          return parseInt(this.$route.params.lotteryId)
        }
      }
    },
    computed: {
      background () {
        if (this.info && this.info.backgroundUrl) {
          return this.info.backgroundUrl
        }
        debugger
      },
      winner () {
        let winner
        if (this.info && this.info.activeResult) {
          this.info.activeResult.filter(e => !e.deleted).map(e => {
            winner = e
          })
        }
        return winner
      }
    },
    data () {
      return {
        info: null,
        results: null,
      }
    },
    async created () {
      try {
        const response = await this.axios.get(`lottery/${this.lotteryId}/`)
        this.info = response.data
        // this.refreshResult()
      } catch (e) {
        console.error(`Не удалось загрузить информацию о лотерее с id ${this.lotteryId}`)
      }
      setInterval(this.refreshResult.bind(this), 1000)
    },
    methods: {
      async refreshResult () {
        try {
          const response = await this.axios.get(`lottery/${this.lotteryId}/`)
          this.info = response.data
          // this.refreshResult()
        } catch (e) {
          console.error(`Не удалось загрузить информацию о лотерее с id ${this.lotteryId}`)
        }
      }
    }
  }
</script>

<style scoped>

</style>
